// Module
var code = "<ul class=\"product-item-labels\"> <li class=\"product-item-labels__label product-item-labels__label--{{::label | lowercase}}\" ng-repeat=\"label in $ctrl.labels\" system-dictionary=\"{{::label}}\"> </li> </ul>";
// Exports
module.exports = code;